function _getTop5(filters) {
    let $loading = $('.ratingList .loading'),
        $rating_place_name = $('.ratingList .rating_place_name');
    $loading.fadeIn();

    if ($rating_place_name.length) {
        $rating_place_name.text(locationService.getLast('Norge'));
    }

    let sp = new SearchParameters(filters);

    sp.parseOptions({size: 5});

    let event = sp.doSearch();

    event.done(function (response) {
        let $result_list = $('.ratingList ul'),
            $noresult_label = $('.ratingList .no-results');

        if (typeof response.result.hits.total !== 'undefined' && response.result.hits.total > 0) {
            $noresult_label.hide();
            composeTop5($result_list, response);
        } else {
            $noresult_label.show();
        }

    }).always(function () {
        $loading.fadeOut();
    });

    return event;
}

function getTop5(filters) {
    'use strict';

    let $loading = $('.ratingList .loading');

    $loading.fadeIn();

    if (filters) {
        searchParams.setFilter(filters.fag_filter || '');
        searchParams.setPath(filters.paths || null);
    } else {
        searchParams.setFilter($.urlParam('filters') || '');
        searchParams.setPath(locationService.getPath());
    }

    let $rating_place_name = $('.ratingList .rating_place_name');

    if ($rating_place_name.length) {
        $rating_place_name.text(locationService.getLast('Norge'));
    }

    searchParams.setQuery('');
    searchParams.setSize(5);

    searchParams.doTop5List()
        .done(function (response) {
            let $result_list = $('.ratingList ul'),
                $noresult_label = $('.ratingList .no-results'),
                total_results = response.result.hits.total;

            $result_list.html('');

            if (total_results > 0) {
                $noresult_label.hide();
                for (let item = 0; item < 5; item++) {
                    let obj = response.result.hits.hits[item];

                    if (typeof obj === 'undefined') {
                        break;
                    }

                    $result_list.append(composeTop5Item(obj, item + 1, response.isGeo));
                }
            } else {
                $noresult_label.show();
            }

        }).always(function () {
        $loading.fadeOut();
    });
}

function composeTop5($container, response) {
    $container.html('');

    let result = response.result.hits.hits.map((i, key) => {
        return composeTop5Item(i, key + 1, response.isGeo)
    });

    $container.append(result.join(' '))
}

function composeTop5Item(result, item, isGeo) {

    return `<li class="clearfix">
        <div class="companyName">
            <a href="/bedrift/${result._id}/${slugify(result._source.name)}">
                ${item}. <strong>${result._source.name}</strong>
            </a>
            ${isGeo ? `<span class="distance">${formatDistance(result.sort)}</span>` : ''}
        </div>
        ${composeResultItemRating(result._source.rating)}
        <div class="companyCategory">
            <a href="#" class="linkIcon">${result._source.alternative_address.replace(/\n/, ', ')}</a></div>
        </li>`;
}

// 'Finn' button inside the 'Velg lokasjon' modal window: finds the nearest kommune based on
// the postnummer inputted by the user
$('#findLatLongByPostnummer_btn').click(function (e) {
    e.preventDefault();

    var postnummer = $('#locationModal [name="postnr"]').val();

    if (postnummer != '') {
        var $loading = $('#locationModal .loading');
        $('#locationModal select').prop('disabled');
        $loading.fadeIn();
        $.get
        (
            '/@mb/pn',
            {
                zip: postnummer
            },
            function (response) {
                $('#locationModal select').removeAttr('disabled');
                if (response.info) {
                    if (response.info.commune.length > 0) {
                        if ($("#locationModal select[name='fylke'] option[value='" + response.info.commune + "']").length) {
                            $('#locationModal select[name="fylke"]').val(response.info.commune);
                        } else {
                            $('#locationModal select[name="fylke"]').append($('<option>', {
                                value: response.info.commune,
                                text: response.info.commune,
                            }));
                            $('#locationModal select[name="fylke"]').val(response.info.commune);
                        }
                    } else {
                        $('#locationModal select[name="fylke"]').val('');
                    }
                    if (response.info.county_name.length > 0) {
                        if ($("#locationModal select[name='kommune'] option[value='" + response.info.county_name + "']").length) {
                            $('#locationModal select[name="kommune"]').val(response.info.county_name);
                        } else {
                            $('#locationModal select[name="kommune"]').append($('<option>', {
                                value: response.info.county_name,
                                text: response.info.county_name,
                                'data-for': response.info.commune,
                            }));
                            $('#locationModal select[name="kommune"]').val(response.info.county_name);
                        }
                    } else {
                        $('#locationModal select[name="kommune"]').val('');
                    }
                    if (response.info.citypart.length > 0) {
                        if ($("#locationModal select[name='sted'] option[value='" + response.info.citypart + "']").length) {
                            $('#locationModal select[name="sted"]').val(response.info.citypart);
                        } else {
                            $('#locationModal select[name="sted"]').append($('<option>', {
                                value: response.info.citypart,
                                text: response.info.citypart,
                                'data-for': response.info.county_name,
                            }));
                            $('#locationModal select[name="sted"]').val(response.info.citypart);
                        }
                    } else {
                        $('#locationModal select[name="sted"]').val('');
                    }
                    $('#chooseNewLocation_btn').attr('data-lat', response.info.lat);
                    $('#chooseNewLocation_btn').attr('data-lon', response.info.lon);
                }
                else {
                    $('#findLatLongByPostnummer_btn')
                        .val('Ingen treff')
                        .addClass('ajax-error');

                    window.setTimeout(function () {
                        $('#findLatLongByPostnummer_btn')
                            .val('Finn')
                            .removeClass('ajax-error');
                    }, 3000);
                }

                $loading.fadeOut();
            }
        );


    }
});

$('#locationModal [name="postnr"]').keypress(function (e) {
    if (e.keyCode === 13) {
        $('#findLatLongByPostnummer_btn').click();
    }
});

// On every change of the 'Kommune' <select> field, fetch on Google for Lat and Long using the selected Kommune
$('#locationModal select[name="kommune"]').change(function () {
    var kommune = $(this).val();


});

// Final button inside the Change Location modal window
$('#chooseNewLocation_btn').on('click.changelocation', function (e) {
    var citypart = $('#locationModal select[name="sted"]'),
        area = $('#locationModal select[name="fylke"]'),
        place = $('#locationModal select[name="kommune"]'),
        selectedLocation = '',
        fag = $('#locationModal').data('fag') || '';

    selectedLocation = citypart.val() || place.val() || area.val();


    $('#locationRecord').replaceWith('<h4 id="locationRecord">' + selectedLocation + '</h4>');

    if (!validateFields($('#locationModal select[name="fylke"]'))) {
        return;
    }

    locationService.setLocation({
        lat: $(this).attr('data-lat'),
        lng: $(this).attr('data-lon'),
        fylke: area.val(),
        kommune: place.val(),
        sted: citypart.val()

    });

    $.get('/@mb/pn', {path: locationService.getPath()}).success(r => {
        if (typeof r.info.lat !== 'undefined') {
            locationService.set('lat', r.info.lat);
            locationService.set('lng', r.info.lon);
        }
    }).always(() => {
        getTop5();
        _initChangeImage(true);

        // getTop5({area: area.val(), cityparts: citypart.val(), place: place.val(), fag_filter: fag});

        $('.ratingList h4 strong').text(selectedLocation);
        $('.changeLocation .rounded strong').text(selectedLocation);
        $('#locationModal .close-reveal-modal').click();
        //scrollWindowTo( $('#frontContent .ratingList') );

        if (imageChanger.changeBackgroundImage) {
            imageChanger.changeBackgroundImage({
                kommune: place.val(),
                fylke: area.val() || place.find('option:selected').data('for')
            });
        }

        _initCheckFilters();

    });

});

$('select[name="fylke"]').on('change.enable-kommune', function () {
    if ($(this).val()) {
        $('select[name="kommune"]').removeAttr('disabled');
    } else {
        $('select[name="kommune"]').val('').attr('disabled', true);
    }
    $('select[name="sted"]').val('').attr('disabled', true);
    $('#locationModal select[name="kommune"]').trigger('change.populate-sted-modal');
});

$('select[name="kommune"]').on('change.enable-bydel', function () {
    if ($(this).val()) {
        $('select[name="sted"]').removeAttr('disabled');
    } else {
        $('select[name="sted"]').attr('disabled', true).val('');
    }
});

function checkBoxes() {
    if (!$('select[name="kommune"]').val()) {
        $('select[name="kommune"]').attr('disabled', true).val();
    }

    if (!$('select[name="sted"]').val()) {
        $('select[name="sted"]').attr('disabled', true).val('');
    }
}

checkBoxes();

/**
 * Check if there is any value.
 * @param {Array} elements
 * @return {Boolean} check
 */
function validateFields(elements) {
    let check = true;
    $(elements).each(function (i, element) {
        if (!$(this).val()) {
            $(this).focus();
            check = false;
            return;
        }
    });

    return check;
}

$('#frontContent .ratingList h4 a').click(function () {
    $('#locationModal').foundation('reveal', 'open');
});
